var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "slider-field",
      class: { "input-half": _vm.half },
      attrs: { "aria-required": _vm.isRequired, "aria-invalid": !_vm.isValid }
    },
    [
      _c(
        "label",
        [
          _c(
            "span",
            {
              staticClass: "slider-label",
              class: {
                "slider-label-large": _vm.largeLabel,
                "slider-label-error-state": _vm.fieldErrors.length
              }
            },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c(
            "span",
            { class: { "slider-label-error-state": _vm.fieldErrors.length } },
            [_vm._t("label")],
            2
          ),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _vm.inlineErrors
        ? _c("error-list", {
            staticClass: "inline-errors",
            attrs: { "aria-only": false, messages: _vm.fieldErrors, prefix: "" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-480192b5", { render: render, staticRenderFns: staticRenderFns })
  }
}